import { render, staticRenderFns } from "./SectionTestimonials.vue?vue&type=template&id=299db2ef&"
import script from "./SectionTestimonials.vue?vue&type=script&lang=js&"
export * from "./SectionTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./SectionTestimonials.vue?vue&type=style&index=0&id=299db2ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default})
